module.exports = __webpack_public_path__ + "static/media/tc.f85cadec.svg";